import React from "react";
import LookupAdmin, { ActiveChip } from "../../components/LookupAdmin";

const TYPE_LABEL = {
  cash: "Caixa",
  bank: "Banco",
  digital_wallet: "Carteira digital",
  gateway: "Gateway"
};

const config = {
  title: "Contas Financeiras",
  subtitle: "Onde o dinheiro entra e sai: banco, caixa, carteira digital. Todo lançamento aponta para uma delas.",
  endpoint: "/finance/accounts",
  labelField: "name",
  fields: [
    { name: "name", label: "Nome", required: true, span: 6 },
    {
      name: "type",
      label: "Tipo",
      type: "select",
      span: 3,
      defaultValue: "cash",
      options: Object.entries(TYPE_LABEL).map(([value, label]) => ({ value, label }))
    },
    { name: "currency", label: "Moeda", span: 3, defaultValue: "BRL" },
    { name: "gatewayProvider", label: "Provedor (gateway)", span: 6 },
    { name: "initialBalance", label: "Saldo inicial", type: "number", span: 3, defaultValue: 0 },
    { name: "active", label: "Ativa", type: "boolean", defaultValue: true },
    { name: "notes", label: "Observações", span: 12 }
  ],
  columns: [
    { key: "name", label: "Nome" },
    { key: "type", label: "Tipo", render: (a) => TYPE_LABEL[a.type] || a.type },
    { key: "currency", label: "Moeda" },
    {
      key: "currentBalance",
      label: "Saldo atual",
      render: (a) =>
        Number(a.currentBalance || 0).toLocaleString("pt-BR", {
          style: "currency",
          currency: a.currency || "BRL"
        })
    },
    { key: "active", label: "Status", render: (a) => <ActiveChip active={a.active} /> }
  ]
};

const FinanceAccounts = () => <LookupAdmin config={config} />;
export default FinanceAccounts;
